// src/lib/menage-providers.js — Phase 4 PR 1 (ADR-076)
// Helpers pour le modèle d'assignation prestataires ménage à 2 niveaux.
//
// Niveau 1 : default_provider par logement (cfg.props[].logs[].menage_default_provider_email).
// Niveau 2 : override par résa (menage_runs.assigned_provider_id, PR 2 à venir).
//
// Source de vérité candidats = cfg.users[].logIds[] (set côté ComptesPanel).
// Comportement (A) silencieux + warning UI si visibilité retirée : on garde
// l'email en cfg, le dropdown affiche un warning sans auto-clear.

/**
 * Liste des comptes ménage qui ont accès à ce logement.
 * Filtre cfg.users[] sur logIds.includes(logementId).
 */
export function getCandidatesForLog(logementId, users) {
  if (!logementId || !Array.isArray(users)) return []
  return users.filter(u => Array.isArray(u.logIds) && u.logIds.includes(logementId))
}

/**
 * Retourne true si le default_provider_email actuel n'est plus dans la liste
 * des candidats valides (compte supprimé OU logement retiré de logIds).
 * Cas (A) silencieux : on n'auto-clear pas, juste warning UI.
 */
export function isProviderOrphan(defaultEmail, candidates) {
  if (!defaultEmail) return false
  return !candidates.some(c => c.email === defaultEmail)
}

/**
 * Helper pour le runtime futur (PR 3 cron veille 18h) : récupère l'email
 * effectif à utiliser pour la création d'un menage_run.
 *  - Si default_provider_email présent ET valide (dans candidats) → return cet email
 *  - Sinon → null (le run sera créé avec assigned_provider_id=NULL, admin
 *    devra l'assigner manuellement dans le planning)
 */
export function getEffectiveDefaultProvider(log, users) {
  const email = log?.menage_default_provider_email
  if (!email) return null
  const candidates = getCandidatesForLog(log.id, users)
  return candidates.some(c => c.email === email) ? email : null
}
